import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=19913e9d&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=19913e9d&lang=scss&scoped=true&"
import style1 from "./CategoryList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19913e9d",
  null
  
)

export default component.exports